import React, {Component} from "react";
import DefiniowanieZamowieniaSekcja from "./sekcja/DefiniowanieZamowieniaSekcja";
import TrasyService from "../../../../trasyConfig/trasy/TrasyService";
import {ButtonToolbar, Checkbox} from "react-bootstrap";
import TopIf from "../../../../../../componentsTopsa/if/TopIf";
import BiletyService from "../../../biletyApi/BiletyService";
import {TopButtonCancel, TopButtonSave} from "../../../../../../componentsTopsa/buttons/TopButtons";
import ValidatorMessages from "../../../../../../shared/validatorMessages/ValidatorMessages";
import LogowanieService from "../../../../../logowanie/LogowanieService";
import ClientBiletyService from "../../../biletyApi/ClientBiletyService";
import LSService from "../../../../../../utilities/localStorageService/LSService";
import KonfiguracjaService from "../../../../../administracja/konfiguracja/KonfiguracjaService";

export default class DefiniowanieZamowieniaForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            czyPowrotny: false,
            godzinyOd: [],
            trasy: [],
            formyPlatnosci: [],
            statusy: [
                {value: 0, label: 'rezerwacja', ikona: 'fa fa-circle-o', kolor: '#333'},
              //  {value: -1, label: 'do opłaty', ikona: 'fa fa-times-circle-o', kolor: '#333'},
                {value: 1, label: 'opłacony', ikona: 'fa fa-check-circle-o', kolor: '#333'},
            ],
            zamowienie: null,


            daneKursPodstawowy: null,
            daneKursPowrotny: null,
            pasazerowiePodstawowy: [],
            pasazerowiePowrotny: [],

            byloKlikniecie:false,

            errmsg: []
        }
        this.odbierzDaneKursu = this.odbierzDaneKursu.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.konwertujIwyslijDoWebservice = this.konwertujIwyslijDoWebservice.bind(this)
    }

    componentDidMount() {

        this.initGodziny()
        this.pobierzKoloryStatusowBiletow()
        this.pobierzTrasy()
        this.pobierzFormyPlatnosci()

    }

    pobierzKoloryStatusowBiletow() {
        KonfiguracjaService.pobierzObiektySekcji('Status-kolor').then(function (response) {
            if (Boolean(response.data)) {

                let arr = response.data.filter(p => p.sekcja === 'Status-kolor')

                let statusyarr = this.state.statusy
                for (let i = 0; i < statusyarr.length; i++) {
                    let statuskolor = arr.find(p => p.pozycja == statusyarr[i].label)
                    if (Boolean(statuskolor)) {
                        statusyarr[i].kolor = statuskolor.wartosc
                    }
                }

                this.setState({statusy: statusyarr})

            }

        }.bind(this))
    }


    pobierzTrasy() {
        TrasyService.getTrasyZRezerwacja().then(function (response) {
            if (response) {
                if (response.status < 300) {
                    this.setState({trasy: response.data})
                }
            }
        }.bind(this))
    }

    pobierzFormyPlatnosci() {
        BiletyService.pobierzFormyPlatnosci().then(function (res) {
            this.setState({formyPlatnosci: res.data})
        }.bind(this))
    }

    initGodziny() {
        let arr = []
        for (let i = 0; i <= 23; i++) {
            if (i < 10) {
                arr.push({value: '0' + i + ':00', label: '0' + i + ':00'})
                arr.push({value: '0' + i + ':30', label: '0' + i + ':30'})
            }
            else {
                arr.push({value: i + ':00', label: i + ':00'})
                arr.push({value: i + ':30', label: i + ':30'})
            }
        }
        this.setState({godzinyOd: arr})
    }


    odbierzDaneKursu(obj, sekcja) {
        if (sekcja === 'podstawowy') {
            this.setState({daneKursPodstawowy: obj})
        }
        else {
            // powrotny
            this.setState({daneKursPowrotny: obj})
        }
    }

    odbierzTablicePasazerow(arr, sekcja) {
        if (sekcja === 'podstawowy') {
            this.setState({pasazerowiePodstawowy: arr})
        }
        else {
            // powrotny
            this.setState({pasazerowiePowrotny: arr})
        }
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.errmsg;
        arr.push(msg)
        this.setState({errmsg: arr})
    }

    onClickZapisz() {

        let poprawne = true;
        this.state.errmsg = [];
        this.setState({errmsg: []})

        // walidacja dotyczaca zamawiajacego

        if (!Boolean(this.props.zamawiajacyKlient)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono danych klienta zamawiającego bilet')
        }
        else {
            if (!Boolean(this.props.zamawiajacyKlient.zamawiajacyNazwisko) || !Boolean(this.props.zamawiajacyKlient.zamawiajacyImie)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Nie uzupełniono imienia i nazwiska klienta zamawiającego bilet')
            }
        }

        // walidacja dotyczaca danych kursu podstawowego

        if (!Boolean(this.state.daneKursPodstawowy)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono danych kursu podstawowego')
        }
        else {
            if (!Boolean(this.state.daneKursPodstawowy.idKu)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Nie wybrano kursu podstawowego')
            }
            if (this.state.daneKursPodstawowy.czyZablok === 2) {
                poprawne = false;
                this.dodajDoValidatorMessages('Wybrany kurs został odwołany')
            }


            // badanie czy nie ma zerowych cennikow
            let znizkaNZ = Boolean(this.state.daneKursPodstawowy.znizki.find(z=>z.rodz=='NZ'))? !Boolean(this.state.daneKursPodstawowy.znizki.find(z=>z.rodz=='NZ').cena) : false
            let znizkaSU = Boolean(this.state.daneKursPodstawowy.znizki.find(z=>z.rodz=='SU'))? !Boolean(this.state.daneKursPodstawowy.znizki.find(z=>z.rodz=='SU').cena) : false

            if(znizkaNZ || znizkaSU){
                poprawne = false;
                this.dodajDoValidatorMessages('Ceny są zerowe - nie uzupełniono cenników trasy podstawowej')
            }

        }

        // walidacja dotyczaca pasazerow podstawowych

        if (this.state.pasazerowiePodstawowy.length === 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono listy pasażerów')
        }
        else {
            for (let i = 0; i < this.state.pasazerowiePodstawowy.length; i++) {
                if (this.state.pasazerowiePodstawowy[i].pasazerImie === '' || this.state.pasazerowiePodstawowy[i].pasazerImie === ' ' ||
                    this.state.pasazerowiePodstawowy[i].pasazerNazwisko === '' || this.state.pasazerowiePodstawowy[i].pasazerNazwisko === ' ') {
                    poprawne = false;
                    this.dodajDoValidatorMessages('Nie uzupełniono pasażera numer ' + (i + 1) + ' w bilecie podstawowym')
                }
            }
        }

        if (this.state.czyPowrotny) {
            // walidacja dotyczaca danych kursu powrotnego
            if (!Boolean(this.state.daneKursPowrotny)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Nie uzupełniono danych kursu powrotnego')
            }
            else {
                if (!Boolean(this.state.daneKursPowrotny.idKu)) {
                    poprawne = false;
                    this.dodajDoValidatorMessages('Nie wybrano kursu powrotnego')
                }
                if (this.state.daneKursPowrotny.czyZablok === 2) {
                    poprawne = false;
                    this.dodajDoValidatorMessages('Wybrany kurs powrotny został odwołany')
                }

                if (Boolean(this.state.daneKursPodstawowy)) {
                    if (this.state.daneKursPodstawowy.data > this.state.daneKursPowrotny.data) {
                        poprawne = false;
                        this.dodajDoValidatorMessages('Kurs powrotny nie może być wcześniejszy niż kurs podstawowy (data)')
                    }
                    else if (this.state.daneKursPodstawowy.data === this.state.daneKursPowrotny.data) {
                        if (Boolean(this.state.daneKursPodstawowy.godzinaOdjazdu) && Boolean(this.state.daneKursPowrotny.godzinaOdjazdu)) {
                            if (parseFloat(this.state.daneKursPodstawowy.godzinaOdjazdu.replace(':', '.')) > parseFloat(this.state.daneKursPowrotny.godzinaOdjazdu.replace(':', '.'))) {
                                poprawne = false;
                                this.dodajDoValidatorMessages('Kurs powrotny nie może być wcześniejszy niż kurs podstawowy (godzina)')
                            }
                        }

                    }

                    // badanie czy nie ma zerowych cennikow
                    let znizkaNZ = Boolean(this.state.daneKursPowrotny.znizki.find(z=>z.rodz=='NZ'))? !Boolean(this.state.daneKursPowrotny.znizki.find(z=>z.rodz=='NZ').cena) : false
                    let znizkaSU = Boolean(this.state.daneKursPowrotny.znizki.find(z=>z.rodz=='SU'))? !Boolean(this.state.daneKursPowrotny.znizki.find(z=>z.rodz=='SU').cena) : false

                    if(znizkaNZ || znizkaSU){
                        poprawne = false;
                        this.dodajDoValidatorMessages('Ceny są zerowe - nie uzupełniono cenników trasy powrotnej')
                    }
                }
            }
            // walidacja dotyczaca pasazerow powrotnych
            if (this.state.pasazerowiePowrotny.length === 0) {
                poprawne = false;
                this.dodajDoValidatorMessages('Nie uzupełniono listy pasażerów w bilecie powrotnym')
            }
            else {
                for (let i = 0; i < this.state.pasazerowiePowrotny.length; i++) {
                    if (this.state.pasazerowiePowrotny[i].pasazerImie === '' ||this.state.pasazerowiePowrotny[i].pasazerImie === ' ' ||
                        this.state.pasazerowiePowrotny[i].pasazerNazwisko === '' || this.state.pasazerowiePowrotny[i].pasazerNazwisko === ' ') {
                        poprawne = false;
                        this.dodajDoValidatorMessages('Nie uzupełniono pasażera numer ' + (i + 1) + ' w bilecie powrotnym')
                    }
                }

            }
        }

        if (poprawne) {
            this.setState({byloKlikniecie:true});
            this.konwertujIwyslijDoWebservice(this.props.zamawiajacyKlient, this.state.daneKursPodstawowy, this.state.pasazerowiePodstawowy, this.state.czyPowrotny, this.state.daneKursPowrotny, this.state.pasazerowiePowrotny)
        }

    }

    konwertujIwyslijDoWebservice(zamawiajacy, kurs1, pasazerowie1, czyPowrot, kurs2, pasazerowie2) {

        let zamowienie = {
            "email": zamawiajacy.email,
            "klientNazwa": zamawiajacy.zamawiajacyNazwisko+' '+zamawiajacy.zamawiajacyImie,
            "telefon": zamawiajacy.telefon,
            "niepowiazane": [],
            "powiazane": [],
        }

        let biletPodstawowyPozycje = []

        for (let i = 0; i < pasazerowie1.length; i++) {
            biletPodstawowyPozycje.push(
                {
                    "data": kurs1.data,
                    "godz": kurs1.godzinaOdjazdu,
                    "idKu": kurs1.idKu,
                    "idPrDo": kurs1.idPrDo,
                    "idPrOd": kurs1.idPrOd,
                    "idPro": pasazerowie1[i].idPro,
                    "idTr": kurs1.idTr,
                    "ile": 1,
                    "klient": pasazerowie1[i].pasazerNazwisko+' '+pasazerowie1[i].pasazerImie,
                    "rodz": pasazerowie1[i].rodz,
                    "statPoz": kurs1.statBil
                }
            )
        }

        let biletPodstawowy =
            {
                "biletyPoz": biletPodstawowyPozycje,
                "formaPlatn": kurs1.formaPlatn,
                "idKl": zamawiajacy.idKl,
                "idUz": LogowanieService.pobierzZalogowanego().idUz,
                "klientEmail": zamawiajacy.email,
                "klientNazwa": zamawiajacy.zamawiajacyNazwisko+' '+zamawiajacy.zamawiajacyImie,
                "klientTelefon": zamawiajacy.telefon,
                "sprzedazMiejsce": "BIURO",
                "statBil": kurs1.statBil,
                "typ": "J",
                "typBiPow": (czyPowrot) ? 'P' : null,
                "waznyDo": (czyPowrot) ? kurs2.data : kurs1.data,
                "waznyOd": kurs1.data
            }


        if (czyPowrot) {
            let biletPowrotnyPozycje = []

            for (let i = 0; i < pasazerowie2.length; i++) {
                biletPowrotnyPozycje.push(
                    {
                        "data": kurs2.data,
                        "godz": kurs2.godzinaOdjazdu,
                        "idKu": kurs2.idKu,
                        "idPrDo": kurs2.idPrDo,
                        "idPrOd": kurs2.idPrOd,
                        "idPro": pasazerowie2[i].idPro,
                        "idTr": kurs2.idTr,
                        "ile": 1,
                        "klient": pasazerowie2[i].pasazerNazwisko+' '+pasazerowie2[i].pasazerImie,
                        "rodz": pasazerowie2[i].rodz,
                        "statPoz": kurs1.statBil
                    }
                )
            }

            let biletPowrotny =
                {
                    "biletyPoz": biletPowrotnyPozycje,
                    "formaPlatn": kurs1.formaPlatn,
                    "idKl": zamawiajacy.idKl,
                    "idUz": LogowanieService.pobierzZalogowanego().idUz,
                    "klientEmail": zamawiajacy.email,
                    "klientNazwa": zamawiajacy.zamawiajacyNazwisko+' '+zamawiajacy.zamawiajacyImie,
                    "klientTelefon": zamawiajacy.telefon,
                    "sprzedazMiejsce": "BIURO",
                    "statBil": kurs1.statBil,
                    "typ": "J",
                    "typBiPow": 'P',
                    "waznyDo": kurs2.data,
                    "waznyOd": kurs1.data
                }


            zamowienie.powiazane.push([biletPodstawowy, biletPowrotny])
        }
        else {
            // tylko podstawowy
            zamowienie.niepowiazane.push(biletPodstawowy)
        }


        ClientBiletyService.dodajZamowienieBiletyJednorazowe(zamowienie).then(function (response) {
            this.props.history.push('/konfiguracja/zarzadzanie-biletami/bilety-jednorazowe')
            LSService.setObj('nowoDodanyBiletEBUS', response.data)
        }.bind(this))


    }

    render() {
        return (
            <div>
                <div>
                    <DefiniowanieZamowieniaSekcja
                        typ={'podstawowy'}
                        trasy={this.state.trasy}
                        statusy={this.state.statusy}
                        formyPlatnosci={this.state.formyPlatnosci}
                        godzinyOd={this.state.godzinyOd}

                        zamawiajacyKlient={this.props.zamawiajacyKlient}

                        handleDaneKursu={this.odbierzDaneKursu}
                        wyslijTablicePasazerowWyzej={(arr) => this.odbierzTablicePasazerow(arr, 'podstawowy')}

                    />

                    <Checkbox checked={this.state.czyPowrotny} onClick={() => {
                        this.setState({czyPowrotny: !this.state.czyPowrotny})
                    }}>Czy powrotny?</Checkbox>

                    <TopIf isTrue={this.state.czyPowrotny}>
                        <div style={{marginBottom: '15px'}}>
                            <DefiniowanieZamowieniaSekcja
                                typ={'powrotny'}
                                trasy={this.state.trasy}
                                statusy={this.state.statusy}
                                formyPlatnosci={this.state.formyPlatnosci}
                                godzinyOd={this.state.godzinyOd}

                                daneKursPodstawowy={this.state.daneKursPodstawowy}
                                pasazerowiePodstawowy={this.state.pasazerowiePodstawowy}

                                handleDaneKursu={this.odbierzDaneKursu}
                                wyslijTablicePasazerowWyzej={(arr) => this.odbierzTablicePasazerow(arr, 'powrotny')}
                            />
                        </div>
                    </TopIf>
                </div>
                <div>
                    <ValidatorMessages messages={this.state.errmsg}/>
                </div>
                <div className={'pull-right'}>
                    <ButtonToolbar>
                        <TopButtonCancel onClick={() => {
                            this.props.history.push('/konfiguracja/zarzadzanie-biletami/bilety-jednorazowe')
                        }}/>
                        <TopButtonSave onClick={this.onClickZapisz} buttonSize={'md'} disabled={this.state.byloKlikniecie}/>
                    </ButtonToolbar>
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/dodajBiletJednorazowy/components/definiowanieZamowienia/DefiniowanieZamowieniaForm.js